import createStyledEnhancer from "../helpers/createStyledEnhancer";
import { composeEnhancers } from "../helpers";
export var displayProperty = createStyledEnhancer({
  name: "display"
});
export var overflow = createStyledEnhancer({
  name: "overflow"
});
export var textOverflow = createStyledEnhancer({
  name: "textOverflow"
});
export var visibility = createStyledEnhancer({
  name: "visibility"
});
export var whiteSpace = createStyledEnhancer({
  name: "whiteSpace"
});
export var zIndex = createStyledEnhancer({
  name: "zIndex",
  addPx: false,
  keys: ["zIndex"]
});
export var display = composeEnhancers(displayProperty, overflow, textOverflow, visibility, whiteSpace, zIndex);
/** Пропсы, которые стайлед будет пытаться преобразовать в атрибуты. Нужны для фильтрации */

export var displayPropsNoForward = ["visibility", "overflow", "display"];